const ProfileStyles = (theme) => ({
	textField: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
		marginTop: 0,
		marginBottom: 0
	},
	paper: {
		margin: theme.spacing.unit * 2,
		maxWidth: 600,
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`
	},
	typography: {
		marginBottom: -15,
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit
	},
	divider: {
		marginTop: 15
	},
	progress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12
	},
	main: {
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'row',
		display: 'flex'
	}
});

export default ProfileStyles;
